import useTranslations from "@/i18n/useTranslations";

const LEVEL_KEYS = {
  Introductory: "levelIntroductory",
  Intermediate: "levelIntermediate",
  Advanced: "levelAdvanced",
} as const;

export const useTranslatedLevel = () => {
  const t = useTranslations("Course");

  return (level?: string): string => {
    if (!level) return "";
    const key = LEVEL_KEYS[level as keyof typeof LEVEL_KEYS];
    return key ? t(key) : level;
  };
};
